// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"0e2b76f7","496":"6bcfd3f7","577":"34f60155"}[chunkId] + ".chunk.js";
};